export const COMPANY = {
  name: "Fix Technical Renovation Company",
  shortName: "Fix Technical",
  category: "Premier Interior Fitting Contractor",
  phone: "0564696327",
  phoneIntl: "+971564696327",
  whatsapp: "0564696327",
  whatsappIntl: "+971564696327",
  whatsappPrefilled:
    "Hello Fix Technical Renovation Company, I am interested in renovation services in Dubai. Please contact me for a free site inspection and quotation.",
  whatsappLink:
    "https://wa.me/971564696327?text=Hello%20Fix%20Technical%20Renovation%20Company%2C%20I%20am%20interested%20in%20renovation%20services%20in%20Dubai.%20Please%20contact%20me%20for%20a%20free%20site%20inspection%20and%20quotation.",
  estimateMessage:
    "Hello Fix Technical Renovation Company, I would like a rough renovation estimate. I am sending photos/videos of my property now.",
  estimateLink:
    "https://wa.me/971564696327?text=Hello%20Fix%20Technical%20Renovation%20Company%2C%20I%20would%20like%20a%20rough%20renovation%20estimate.%20I%20am%20sending%20photos%2Fvideos%20of%20my%20property%20now.",
  email: "info@interiorsfitout.com",
  address: "Al Fattan Business Hub, Office Square, Marsa Dubai Marina, Dubai, UAE",
  addressShort: "Al Fattan Business Hub, Dubai Marina, UAE",
  city: "Dubai",
  country: "United Arab Emirates",
  geo: { lat: 25.0762, lng: 55.1313 },
  serviceAreas: [
    "Dubai Marina",
    "JBR",
    "Downtown Dubai",
    "Business Bay",
    "Palm Jumeirah",
    "Jumeirah",
    "Dubai Hills",
    "Mohammed Bin Rashid City",
    "Arabian Ranches",
    "Motor City",
    "Jumeirah Village Circle (JVC)",
    "Jumeirah Lake Towers",
    "Al Barsha",
    "Damac Hills",
    "Dubai Creek Harbour",
    "Al Furjan",
    "Barsha Heights",
  ],
};

export const PROJECT_TYPES = [
  "Apartment Renovation",
  "Villa Renovation",
  "Full Home Renovation",
  "Bathroom Renovation",
  "Kitchen Renovation",
  "Interior Fit-Out",
  "Commercial Fit-Out",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1682184805271-11671b7ecf4c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  apartment: "https://images.unsplash.com/photo-1581541470376-f55e19a5718c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  villa: "https://images.unsplash.com/photo-1724582586495-d050726cf354?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  home: "https://images.unsplash.com/photo-1779648596373-274e9d81ad80?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bathroom: "https://images.unsplash.com/photo-1663811396038-7a21d4eef49e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kitchen: "https://images.unsplash.com/photo-1663811396681-8d1e6caa4da9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  trustBg: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  living: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  joinery: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  penthouse: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
